<sdc-bo-dialog
  headerTitle="CSV data preview"
  [styleClass]="['variant-prominent-title']">
  @if (data.length === 0) {
    <div class="error-container">
      Error parsing the file. Please, note that the separator must be a
      semicolon
    </div>
  }

  @if (hasErrors && !isUploaded) {
    <div class="error-container">
      The highlighted fields are invalid. Please, fix them and upload the file
      again
    </div>
  }

  @if (hasErrors && isUploaded) {
    <div class="error-container">
      The highlighted rows were not saved because the username exist already
    </div>
  }

  <main class="content-wrapper">
    @if (data.length > 0) {
      <div class="default-table v2">
        @if (refreshing) {
          <div class="loading">
            <div class="text-container">
              <div>
                <span>Saving users</span>
              </div>
              <div>
                <div class="dot-typing"></div>
              </div>
            </div>
          </div>
        }
        <table>
          <thead>
            <tr>
              @if (isUploaded) {
                <th>Id</th>
              }
              <th>Username</th>
              <th>Password</th>
              <th>Email</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            @for (user of data; track user; let i = $index) {
              <tr>
                @if (isUploaded) {
                  <td>{{ user.id }}</td>
                }
                <td
                  [class.invalid-field]="
                    validationResult[i]['username'] || (isUploaded && !user.id)
                  ">
                  {{ user.username }}
                </td>
                <td
                  [class.invalid-field]="
                    validationResult[i]['password'] || (isUploaded && !user.id)
                  ">
                  {{ user.password }}
                </td>
                <td
                  [class.invalid-field]="
                    validationResult[i]['email'] || (isUploaded && !user.id)
                  ">
                  {{ user.email }}
                </td>
                <td
                  [class.invalid-field]="
                    validationResult[i]['type'] || (isUploaded && !user.id)
                  "
                  style="text-align: center">
                  {{ user.type }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </main>

  <ng-container sdc-bo-dialog-footer>
    @if (data.length === 0 || hasErrors) {
      <sdc-button variant="primary" (onClick)="onDismiss('cancel')">
        Close
      </sdc-button>
    }

    @if (data.length > 0 && !hasErrors) {
      @if (!isUploaded) {
        <sdc-button variant="secondary" (onClick)="onDismiss('cancel')">
          Cancel
        </sdc-button>
      }
      <sdc-button variant="primary" (onClick)="onConfirm()">
        {{ isUploaded ? 'Close' : 'Save' }}
      </sdc-button>
    }
  </ng-container>
</sdc-bo-dialog>
